<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <div>
            <h2>Digital Archive on Weaving, Textiles, Lace, and Related Topics</h2>
            <hr />
            <h3 class='inline-auto-width'>{{daItem.DocumentTypeName}}: {{daItem.Title}}</h3>
            <share-button/>
            <hr />
        </div>

        <span style='font-style: italic' v-if='(daItem.AuthorID && daItem.AuthorID > 0)'>
            <router-link :to='buildDocumentSearchTypeUrl("author", daItem.AuthorID, daItem.AuthorName)'>{{ daItem.AuthorName }}</router-link>
        </span><span v-if='((daItem.Pub && daItem.PubID> 0) || (daItem.DateVolumeIssue && daItem.DateVolumeIssue.length > 0))'>,
            <span>Pub: </span>{{ daItem.DateVolumeIssue }}
            <router-link :to='buildDocumentSearchTypeUrl("publication", daItem.SourcePubID, daItem.PubName)'>{{ daItem.PubName }}</router-link>
        </span><span v-if='(daItem.Language && daItem.Language.length> 0)'>,
            <router-link :to='buildDocumentSearchTypeUrl("language", daItem.Language, daItem.Language)'>{{ daItem.Language }}</router-link>
        </span><span v-if='(daItem.TopicsList && daItem.TopicsList.length > 0)'>,
            <span :key='topic.ID' v-for='topic in daItem.TopicsList'>
                <router-link :to='buildDocumentSearchTypeUrl("topic", topic.ID, topic.Name)'>{{ topic.Name }}</router-link>&nbsp;
            </span>
        </span>
        <div v-if='(daItem.Notes && daItem.Notes.length > 0)'>
            <span v-html='daItem.Notes'></span>
        </div>

        <div v-if="isAuthenticated">
            Hint: To save for later, right-click the filename and choose Save...
        </div>

        <hr/>
        <h3>Available Files</h3>

        <div :key='file.FileId' v-for="file in downloadableFiles">
            <hr/>
            <login-control v-if="!isAuthenticated" :prompt='file.Filename' :show-as-link='true' />
            <a title='Download File' v-if="isAuthenticated" target='_blank' @click='recordAnalytics(file.FileId)' :href='file.Url' :download='file.Filename'>{{ file.Filename }}</a>,
            ({{ file.ContentType }})
            <login-control v-if="!isAuthenticated" prompt='Download' :show-as-link='false' />
            <b-button variant='primary' title='Download File' v-if="isAuthenticated" target='_blank' @click='recordAnalytics(file.FileId)' :href='file.Url' :download='file.Filename'>Download</b-button>
        </div>

        <div class="row top-padding">
            <img style='max-width: 100%; vertical-align: top' :src='sample.Url'>
            <img style='max-width: 100%; vertical-align: top' :src='cover.Url' />
        </div>

        <related-store-products :da-item-id='daItemId'/>

        <helpUsButton/>
        <mailChimpSignup/>
    </b-container>

</template>

<script>
import dataService from '../mixins/dataService.js'
import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import relatedStoreProducts from './RelatedStoreProducts.vue'
import loginControl from './LoginControl.vue'
import shareButton from './ShareButton.vue'

export default {
    mixins: [dataService, mediaService, urlsService],
    data: function() {
        return {
            daItem: {
                ItemID: 0,
                DocumentTypeName: '',
                Title: ''
            },
            daItemId: 0,
            downloadableFiles: [],
            productsList: [],
            sample: {
                Url: ''
            },
            cover: {
                Url: ''
            }
        }
    },
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        relatedStoreProducts: relatedStoreProducts,
        loginControl: loginControl,
        shareButton: shareButton
    },
    methods: {
        initializeComponent() {
            this.getDAItem(this.$route.params.id).then(resp => {
                this.daItem = resp.data
                this.daItemId = this.daItem.ItemID
                this.$store.commit('setPageTitle', 'Document | ' + this.daItem.Title + ', ' + this.daItem.AuthorName)
            })
            this.getDAItemFiles(this.$route.params.id).then(resp => {
                let itemsList = resp.data

                let coversList = this.getDAItemFilesOfType(itemsList, 'Cover')
                if (coversList.length > 0) {
                    this.cover = coversList[0]
                }

                let samplesList = this.getDAItemFilesOfType(itemsList, 'Sample')
                if (samplesList.length > 0) {
                    this.sample = samplesList[0]
                }

                let contentsList = this.getDAItemFilesOfType(itemsList, 'Contents')
                let multipleList = this.getDAItemFilesOfType(itemsList, 'Multiple')
                let singleList = this.getDAItemFilesOfType(itemsList, 'Single')
                let reviewList = this.getDAItemFilesOfType(itemsList, 'Review')
                this.downloadableFiles = contentsList.concat(multipleList, singleList, reviewList)
            })
            this.getDAItemProducts(this.$route.params.id).then(resp => {
                this.productsList = resp.data
            })
        },
        getDAItemFilesOfType(allFilesList, fileType) {
            let items = []
            for (let c = 0; c < allFilesList.length; c++) {
                if (allFilesList[c].ContentType === fileType) {
                    items.push(allFilesList[c])
                }
            }
            return items
        },
        recordAnalytics(daItemFileId) {
            this.postAnalytics(this.authUser.UserID, daItemFileId, 0, true)
        }
    },

    watch: {
        '$route.params.id': function() {
            this.initializeComponent()
        }
    },

    computed: {
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },

        authUser: function() {
            return this.$store.state.authUser
        }
    },
    created() {
        this.initializeComponent()
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/DocumentDetail.vue